import React from 'react'
import StyledFlexContainer from './../../../components/containers/flex-container.component'
import Yup from './../../../helpers/custom-yup'
import ProductGridItem from './product-grid-item.component'
import { SelectInput } from '../../../components/form-components/inputs.component.jsx'
import { Formik, Form } from 'formik'
import { isMobile } from '../../../services/breakpoints.service'

const sortOptions = [
	{ value: 'creationdate', label: 'Novidades' },
	{ value: 'pointsdesc', label: 'Pontos (maior-menor)' },
	{ value: 'pointsasc', label: 'Pontos (menor-maior)' },
	{ value: 'nameasc', label: 'Nome (A-Z)' },
	{ value: 'namedesc', label: 'Nome (Z-A)' }
]
const initialValues = {
	sord: 'creationdate'
}

const itemsContainerStyle = {
	display: 'flex'
}

const schema = Yup.object()

class ProductsGrid extends React.Component {
	constructor(props) {
		super(props)

		this.state = { products: [] }

		this.onSubmit = onSubmit.bind(this)
		this.onValueChange = onValueChange.bind(this)
		this.renderProducts = renderProducts.bind(this)
	}

	componentDidMount() {
		this.fetchData(this.refs.form.state.values)
	}

	fetchData({ sord }) {
		this.props
			.fetchData({ sord })
			.then(({ data }) => this.setState({ products: data }))
	}

	render() {
		return (
			<Formik
				ref={'form'}
				initialValues={initialValues}
				onSubmit={this.onSubmit}
				validationSchema={schema}
				render={props => (
					<Form className="form" noValidate>
						<StyledFlexContainer>
							<SelectInput
								defaultValue={{ value: '', label: '' }}
								onValueChange={this.onValueChange}
								label={'Ordernar por'}
								options={sortOptions}
								className={'col-3'}
								multi={false}
								id={'sord'}
								{...props}
							/>
							<StyledFlexContainer
								style={itemsContainerStyle}
								marginTop={0.3}
								className={'col-12'}
								alignItems={'flex-start'}>
								{this.renderProducts()}
							</StyledFlexContainer>
						</StyledFlexContainer>
					</Form>
				)}
			/>
		)
	}
}

function renderProducts() {
	return (
		<React.Fragment>
			{this.state.products.map(
				(
					{
						id,
						points,
						imageUrl,
						description,
						secondPrice,
						secondPoints,
						pointsForSubscribers,
						priceNotMember,
						priceForMember
					},
					index
				) => (
					<React.Fragment key={index}>
						{isMobile() && index > 0 ? <hr /> : null}
						<ProductGridItem
							id={id}
							points={points}
							imageUrl={imageUrl}
							className={'col-3'}
							description={description}
							secondPrice={secondPrice}
							secondPoints={secondPoints}
							pointsForSubscribers={pointsForSubscribers}
							priceNotMember={priceNotMember}
					    	priceForMember={priceForMember}

						/>
					</React.Fragment>
				)
			)}
		</React.Fragment>
	)
}

function onSubmit() {}
function onValueChange(sord) {
	this.fetchData({ sord })
}

export default ProductsGrid
